import { formatters } from '@/core';
import { DATE_FORMAT_MOMENT } from '@/platform';
import moment from 'moment';

interface Props {
  value: Date | string | undefined;
  className?: string;
  applyOffset?: boolean;
}

export const DateValue = (props: Props) => {
  const { value: valueProp, className, applyOffset = true } = props;
  const value = moment.utc(valueProp);

  return !valueProp ? null : (
    <span className={className}>
      {value.isValid()
        ? formatters.dateTime(valueProp, 'date', { applyOffset: applyOffset })
        : DATE_FORMAT_MOMENT}
    </span>
  );
};
